module.exports = __webpack_public_path__ + "static/img/img-no2.3e427c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-no2.png
// module id = nNCD
// module chunks = 0